export const storeWaitTimeRateList = (state, waitTimeRateList) => {
  state.waitTimeRateList = [...waitTimeRateList];
};
